export default __webpack_public_path__ + "static/media/secured-payments.fbc878fb.svg";